module.exports = __webpack_public_path__ + "static/before-60ef9359e4b94d064a0cacd608231069.png";